module.exports = function() {
  return new Worker(__webpack_public_path__ + "af216de0c692868144e5.worker.js");
};